import {Link} from 'external/react'
import Icon from 'external/fortawesome'
import { clsx } from 'external/clsx'

export default function PurchasePackage () {
    return (
        <div className='col-lg-4 col-md-6 d-flex pb-3'>
            <Link to={'/offers'} className='d-inline-block text-decoration-none w-100'>
                <div className={clsx('container__selectedCourse', 'buy-package')}>
                    <Icon name='faCirclePlus' color='#CCCCCC' className='plus-rounded-default fa-3x' />
                    <Icon name='faCirclePlus' color='#1797D0' className='plus-rounded-active fa-3x' />
                    <span>
                        Compra un <br /> nuevo paquete
                    </span>
                </div>
            </Link>
        </div>
    )
}